import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  SKUBatchInventoryTrackSearchCriteria,
  RestSKUBatchInventoryTrackListRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListRequest,
  RestReadRequest,
} from "../../Ds/ds";
import SelectOption from "../../Components/Base/SelectOption";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
  getSuggestions,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_THEME_COLOR,
  TOAST_WARN,
} from "../../Utils/appConstants";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import Modal from "../../Components/Modal";
import AutoComplete from "../../Components/Base/AutoComplete";
export default function RollingInventoryDetailsInquiry() {
  const title = "Rolling Inventory";
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  const [code, setCode] = useState("");
  const [rollingInventories, setRollingInventories] = useState([]);
  const [criteria, setCriteria] = useState(
    new SKUBatchInventorySearchCriteria()
  );
  const [suggestions, setSuggestions] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowEntityModal, setIsShowEntityModal] = useState(false);
  const [entityData, setEntityData] = useState(null);
  const [qtyList, setQtyList] = useState([]);
  const [items, setItems] = useState([]);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    setFocus();
    getItemList();
  }, []);
  const handleGetItemListResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.fabricStylePageList) &&
          !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
        ) {
          const _list = new Array();
          response.data.fabricStylePageList.fabricStyles.map((ln) => {
            _list.push(ln.code);
          });
          setItems(_list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getItemList = () => {
    if (SecurityAccessManager.ItemMaintenanceView_IsAccessible()) {
      const request = new RestFabricStyleListRequest();
      const criteria = new FabricStyleSearchCriteria();
      criteria.companyCode = process.env.REACT_APP_COMPANY;
      if (!isEmpty(session)) {
        const { entityCode, code } = session;
        if (!isEmptyString(entityCode))
          criteria.logisticCustomerCode = entityCode;
        if (!isEmptyString(code)) criteria.customerUserCode = code;
      }
      const pageInput = new PageListBean();
      // pageInput.currentPage = 1;
      // pageInput.pageSize = pageSize;

      request.searchCriteria = criteria;
      request.pageInput = pageInput;

      const path = "getItemListBasedOnCustomer";
      service(token, path, request, handleGetItemListResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };
  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const generateReport = (type) => {
    // const criteria = new SKUBatchInventoryTrackSearchCriteria();
    // criteria.fabricStyleCode = code;
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode))
        criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    const request = new RestSKUBatchInventoryTrackListRequest();
    request.searchCriteria = criteria;
    request.reportBean = reportBean;
    const path = "generateRollingInventoriesDetailsPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };
  const PDFHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
    // ) {
    setIsLoading(true);
    generateReport(1);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ExcelHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
    // ) {
    setIsLoading(true);
    generateReport(2);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ResetHandler = () => {
    setCode("");
    setRollingInventories([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setFocus();
    setCriteria(new SKUBatchInventoryTrackSearchCriteria());
  };
  const ExecuteHandler = () => {
    loadPage(1);
  };
  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };
  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };
  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          setRollingInventories(response.data.resultBean.infos);
          setIsShowExcel(true);
          setIsShowPdf(true);
        }
        if (
          !isEmpty(response.data.resultBean) &&
          isEmptyArray(response.data.resultBean.infos)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const loadPage = (id) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    setRollingInventories([]);
    setIsLoading(true);
    // const criteria = new SKUBatchInventoryTrackSearchCriteria();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    // criteria.fabricStyleCode = criteria.fabricStyleCodeContains;
    // criteria.fabricStyleCodeContains = code;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode))
        criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }

    const path = "inquireRollingInventories";
    service(token, path, criteria, handleResponse, errorCallBack);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const loadFirst = () => {
    loadPage(1);
  };
  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };
  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };
  const loadLast = () => {
    loadPage(maxPage);
  };
  const enterKeyHandler = (e) => {
    loadFirst();
  };
  const onChange = (e) => {
    const criteria = new SKUBatchInventorySearchCriteria();
    criteria[e.target.name] = e.target.value.toUpperCase();
    setCriteria(criteria);
    setSuggestions(getSuggestions(items, e.target.value));
  };
  // const onChange_ = (e) => {
  //   // setCode(e.target.value.toUpperCase());
  //   const { name, value, type, checked } = e.target;
  //   const inputValue = type === "checkbox" ? checked : value;
  //   setCriteria((prevState) => ({
  //     ...prevState,
  //     [name]:
  //       type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
  //   }));
  //   setSuggestions(getSuggestions(items, value));
  // };
  const handleReadResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.fabricStyle)) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        setCriteria(criteria);
        setSuggestions([]);
      }
    }
  };
  const readItemCode = (code) => {
    const path = "readFabricStyle";
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.code = code;
    request.isLoadChildren = true;

    service(token, path, request, handleReadResponse, errorCallBack);
  };
  const clickHandler = (e) => {
    let itemCode = e.target.value;
    readItemCode(itemCode);
  };
  const buttonHandler = (e) => {
    loadFirst();
  };
  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };
  const onClose = () => {
    setIsAccessible(false);
  };
  const closeModal = () => {
    setIsShowModal(false);
    setIsShowEntityModal(false);
  };

  const qtyClickHandler = (e, val, rowData) => {
    setIsShowModal(true);
    getOnHandQuantityLines(rowData);
  };
  const handleGetOnHandQtyListResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.inventoryTrackPageList) &&
          !isEmptyArray(
            response.data.inventoryTrackPageList.skuBatchInventoryTracks
          )
        ) {
          const list = new Array();
          const result =
            response.data.inventoryTrackPageList.skuBatchInventoryTracks;
          result.map((ln) => {
            list.push(ln);
          });
          setQtyList(list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          setIsShowModal(false);
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getOnHandQuantityLines = (data) => {
    const criteria = new SKUBatchInventoryTrackSearchCriteria();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.fabricStyleCode = data.itemCode;
    criteria.containerNumber = data.containerNumber;
    criteria.updateEntityCode = data.entityCode;
    criteria.updateEntityType = data.entityType;
    const pageInput = new PageListBean();
    const request = new RestSKUBatchInventoryTrackListRequest();
    request.searchCriteria = criteria;
    request.pageInput = pageInput;

    setIsLoading(true);
    setQtyList([]);
    const path = "getSkuBatchInventoryTrackPageList";
    service(
      token,
      path,
      request,
      handleGetOnHandQtyListResponse,
      errorCallBack
    );
  };
  const entityClickHanlder = (e, val, rowData) => {
    setIsShowEntityModal(true);
    setEntityData(rowData);
    getEntityDetails(rowData);
  };
  const getEntityDetails = () => {
    //
  };
  const quantityColumns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "7", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "onHandQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("WHPO#", "warehousePurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("SERIAL# ", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("IMEI#", "imeiNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Pallet#", "palletNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Process", "updateEntityCode", true)
        .setStyleDetails("left", "", "", "wt-6", "wt-6")
        .setSpecialDetails(true, "updateEntityType", entityClickHanlder)
      // .setClickDetails(true, false, entityClickHanlder, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Ref#", "customerReferenceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    return _columns;
  };
  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "itemCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "", true)
        .setStyleDetails("center", "", "", "", "")
        .setSpanDetails(false, true, 3)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "startQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ChangeQty", "changeQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, qtyClickHandler, null)
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CloseQty", "endQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Process", "entityCode", true)
        .setStyleDetails("left", "", "", "wt-6", "wt-6")
        .setSpecialDetails(true, "entityType", entityClickHanlder)
      // .setClickDetails(true, false, entityClickHanlder, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Date", "date", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );

    return _columns;
  };
  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        isOpen={isShowModal}
        onClose={closeModal}
        title={"OnHandQty Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(qtyList) && qtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={quantityColumns}
              data={qtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>
      {!isEmpty(entityData) ? (
        <Modal
          isOpen={isShowEntityModal}
          onClose={closeModal}
          title={entityData.entityType}
          cstmClassName="modal_content_width_70"
        >
          <div className="div_cstm_ht"></div>
        </Modal>
      ) : null}

      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

      <div className="card-body">
        <div className="row">
          {/* <div className="form-group col-5">
            <InputTextBox
              value={code}
              required={true}
              name="code"
              placeholder={"Enter item code"}
              label={"Item Code"}
              enterKeyHandler={enterKeyHandler}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
            /> 

            <SelectOption
              // value={code}
              value={criteria.fabricStyleCode}
              required={true}
              name="fabricStyleCode"
              // name="code"
              label={"Item Code"}
              enterKeyHandler={enterKeyHandler}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
              options={items}
            /> 
          </div>*/}
          <div className="form-group col-5">
            <InputTextBox
              suggestions={suggestions}
              value={criteria.fabricStyleCode}
              onChange={onChange}
              label={"ItemCode"}
              name="fabricStyleCode"
              clickHandler={(e) => clickHandler(e)}
              disable={disable}
              enterKeyHandler={enterKeyHandler}
              inputRef={inputRef}
              required={true}
            />
          </div>

          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {/* {!isEmptyArray(rollingInventories) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null} */}
      {!isEmptyArray(rollingInventories) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}

      {!isEmptyArray(rollingInventories) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>Rolling Inventory Details</h1>
          </div>
          <div className="list-wrap">
            {view === 2 ? (
              <>
                {" "}
                <CustomTable
                  columns={Columns}
                  data={rollingInventories}
                  isShowFullScreen={true}
                  isEnableSpan={true}
                />
              </>
            ) : (
              <>
                {rollingInventories.map((roll, idx) => {
                  return (
                    <div className="list-itm" key={idx}>
                      <div className="">
                        <span className="_imp">{roll.itemCode}</span>
                      </div>

                      <div className="">
                        <span className="_imp">{roll.entityCode}</span> -{" "}
                        {roll.entityType}
                      </div>
                      <div className="tb-flex">
                        <div>OnHand Qty</div>
                        <div>
                          ({" "}
                          <span className="_imp">
                            {toCommaSeperatedAmount(roll.endQuantity)}
                          </span>{" "}
                          )
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div className="sub-tb-flex">
                          <div>Open</div>/<div>Change</div>
                        </div>
                        <div className="sub-tb-flex">
                          <div>
                            {toCommaSeperatedAmount(roll.startQuantity)}
                          </div>
                          /
                          <div
                            className="hyperLink"
                            onClick={(e) =>
                              qtyClickHandler(e, roll.changeQuantity, roll)
                            }
                          >
                            {toCommaSeperatedAmount(roll.changeQuantity)}
                          </div>
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div className="sub-tb-flex">
                          <div>UOM</div>
                        </div>
                        <div className="sub-tb-flex">
                          <div>{roll.uomCode}</div>/
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div className="sub-tb-flex">
                          <div>Date</div>
                        </div>
                        <div className="sub-tb-flex">
                          <div>{roll.date}</div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
